import { request } from './client';
import type { PendingScoreUpdate } from '../types';

export const liveScoresApi = {
  getPendingScores: (boardId: string): Promise<PendingScoreUpdate[]> =>
    request(`/api/squareup/boards/${boardId}/pending-scores`),

  approvePendingScore: (boardId: string, updateId: string): Promise<unknown> =>
    request(`/api/squareup/boards/${boardId}/pending-scores/${updateId}/approve`, {
      method: 'POST',
    }),

  dismissPendingScore: (boardId: string, updateId: string): Promise<void> =>
    request(`/api/squareup/boards/${boardId}/pending-scores/${updateId}/dismiss`, {
      method: 'POST',
    }),

  editPendingScore: (
    boardId: string,
    updateId: string,
    scores: { homeScore: number; awayScore: number }
  ): Promise<void> =>
    request(`/api/squareup/boards/${boardId}/pending-scores/${updateId}`, {
      method: 'PATCH',
      body: scores,
    }),
};
